import { render, staticRenderFns } from "./high_end_register.vue?vue&type=template&id=6228db06&scoped=true&"
import script from "./high_end_register.vue?vue&type=script&lang=js&"
export * from "./high_end_register.vue?vue&type=script&lang=js&"
import style0 from "./high_end_register.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./high_end_register.vue?vue&type=style&index=1&id=6228db06&lang=stylus&scoped=true&"
import style2 from "./high_end_register.vue?vue&type=style&index=2&lang=stylus&"
import style3 from "./high_end_register.vue?vue&type=style&index=3&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6228db06",
  null
  
)

export default component.exports